<template>
    <div class="asset-details">
        <dl class="item-title" v-if="dataList.length > 0">
            <dt>资产名称</dt>
            <dd>金额(元)</dd>
        </dl>
        <div class="content" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
            <dl class="item-content" v-for="(item, index) in dataList" :key="index">
                <dt>{{item.name}}</dt>
                <dd>{{item.principal}}</dd>
            </dl>
            <div v-if="dataList.length === 0 && !loading" class="no-data">
                <img src="../../../assets/images/normal/null_icon_data.png" alt="暂无数据"/>
                <p>
                    暂无数据
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import infiniteScroll from "vue-infinite-scroll";

    export default {
        name: "assetDetails",
        data() {
            return {
                productCode: "",
                dataList: [],
                busy: false,
                loading: true
            };
        },
        directives: {infiniteScroll},
        created() {
            let params = this.$route.query;
            const {productCode, token, dealNo, contractSplit} = params;
            this.productCode = productCode;
            this.contractSplit = contractSplit;
            this.dealNo = dealNo;
            this.token = decodeURIComponent(token || "");
        },
        methods: {
            loadMore: (function () {
                let pageNo = 1;
                return function () {
                    let dataType = 1;
                    let url = '/hjiaProduct/productLoans.json';
                    let data = this.$qs.stringify({
                        pageNo,
                        productCode: this.productCode,
                        loanStatus: 1,
                        token: this.token
                    });
                    if (this.dealNo && this.contractSplit == '2') {
                        dataType = 2;
                        url = '/h5/deal/dealLoans.json';
                        data = this.$qs.stringify({
                            no: this.dealNo,
                            pageNo,
                            "pageSize": 20,
                            token: this.token
                        })
                    }
                    this.$request({
                        url,
                        data
                    })
                        .then(res => {
                            this.loading = false;
                            let dataArr;
                            if (dataType === 1) {
                                dataArr = res.data.productLoans;
                            } else {
                                dataArr = res.data.dealLoans;
                            }
                            if (dataArr.length === 0) {
                                return (this.busy = true);
                            }
                            pageNo++;
                            this.dataList.push(...dataArr);
                        })
                        .catch(err => {
                            this.$toast(err);
                        });
                };
            })(),
        }
    };
</script>

<style lang="less">
    .asset-details {
        .no-data {
            height: 100vh;
            background: #FFFFFF;
            overflow: hidden;

            img {
                display: block;
                width: 120px;
                height: 120px;
                margin: 80px auto 20px;
            }

            p {
                font-size: 14px;
                color: #aaaaaa;
                text-align: center;
            }
        }

        .item-title {
            display: flex;
            font-size: 14px;
            padding: 0 16px;
            height: 44px;
            line-height: 44px;
            align-items: center;
            color: #888888;
            font-family: PingFangSC-Regular, serif;

            dt {
            }

            dd {
                flex: 1;
                text-align: right;
            }
        }

        .content {
            background: #FFFFFF;
            padding: 12px 0;
            border-radius: 24px;
        }

        .item-content {
            display: flex;
            font-size: 14px;
            margin: 0 16px;
            height: 44px;
            line-height: 44px;
            border-bottom: 1px solid #EBEBEB;
            color: #333333;

            dt {
            }

            dd {
                flex: 1;
                text-align: right;
                color: #333333;
            }

            &:last-child {
                border-bottom: 0
            }
        }
    }
</style>
